var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Sorry you got a wrong answer, please try again")]),_c('router-link',{attrs:{"to":{name:'Home'}}},[_vm._v("Try Again")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }